module.exports = __webpack_public_path__ + "static/media/保腎護心網layout物件V3_33.2b35fc94.png";